import { Scene, Choice, Dialog } from "../models";
import { scenes } from "../scenes";
import { yang } from "@/images";

let glennDialog = [
  new Dialog(
    "SONNY YANG: Glenn, how would you feel about going for a little wander? I could use some hired muscle.",
    yang,
    require("@/audio/Pandemic-79-Sonny-MP3.mp3")
  ),
  new Dialog(
    "GLENN: Anything you want boss.",
    require("@/images/glenn.png"),
    require("@/audio/Pandemic-79-Glenn-MP3.mp3")
  ),
  new Dialog(
    "[GLENN HAS JOINED YOUR PARTY]",
    require("@/images/glenn.png"),
    require("@/audio/Found_Jingle.mp3")
  ),
];

let glennSmallTalks = [
  new Dialog(
    "SONNY YANG: Top of the morning Glenn, what’s been happening ?",
    yang,
    require("@/audio/Pandemic-78-Sonny-MP3.mp3")
  ),
  new Dialog(
    "GLENN: Not much man.",
    require("@/images/glenn.png"),
    require("@/audio/Pandemic-78-Glenn-MP3.mp3")
  ),
];

export class GlennsHouse extends Scene {
  image = require("@/images/glenn.png");
  title = "Inside Glenn's House";
  get options() {
    return [
      new Choice("Make Small Talk", () => {
        this.dialogRunner(glennSmallTalks);
      }),
      new Choice("Ask Him for a Favour", async () => {
        this.state.storylines.findGlenn = false;
        this.state.inventory.glenn.has = true;
        await this.dialogRunner(glennDialog)
        await this.navigate(scenes.GlennsHouseExterior());
      }),
      new Choice("Leave Him Alone", async () =>
        await this.navigate(scenes.GlennsHouseExterior())
      ),
    ];
  }
}

export default new GlennsHouse();
